import { EMAIL } from './EMAIL';
import { MESSAGES_COPY } from '../messages/COPY';
import { PLACEHOLDERS_COPY } from '../placeholders/COPY';

export const STAKEHOLDER_EMAIL = {
	PATTERN: EMAIL.PATTERN,
	PLACEHOLDER: PLACEHOLDERS_COPY.STAKEHOLDER_EMAIL,
	VALIDATION_MESSAGE: MESSAGES_COPY.PLEASE_ENTER_EMAIL
};
